import { BaseService, NOME_TOKEN_ACESSO_DIRETO } from '@thema/base-servicos'

const urlContrato = '/service/contabilidade/transparencia/contrato/'

class EmpenhosContratoService extends BaseService {
    constructor() {
        const config = JSON.parse(sessionStorage.getItem('config'))
        super(NOME_TOKEN_ACESSO_DIRETO, config)
    }

    consultarEmpenhoRecursoConcedido(filtro) {
        let data = {
            exercicio: filtro.exercicio,
            codigo: filtro.numero,
        }

        return this.conex.post(urlContrato + 'empenhosRecursoConcedido/', JSON.stringify(data))
    }
}

export default EmpenhosContratoService
